/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {RenderElement} from "App/model/elements/element";
import Description from "App/model/description";
import {Factory} from "App/model/elements/factory";
import GlobeModel from "App/model/elements/globe_model";

export default
class Octree extends RenderElement {

    public static TypeName: string = "Octree";
    private _patches: any[];

    constructor(aModelDescription: Description) {
        super(aModelDescription);

        this._patches = [];
    }

    public static create(aModelDescription: Description, aUID: number): Octree {
        let obj = new Octree(aModelDescription);
        obj._typeName = Octree.TypeName;
        obj._UID = aUID;
        return obj;
    }

    public parse(aElementDescriptionJSON: any): boolean {
        let ret = super.parse(aElementDescriptionJSON);
        if (!ret) {
            return false;
        }

        // let's crete a new globe model
        if (!this._modelDescription.getSceneAPI().globe) {

            // get annotations data for get parameters of the patch
            let annotation = this._modelDescription.annotations.getAnnotationByUID(aElementDescriptionJSON.annotations[0]);
            let annotationDataObject = JSON.parse(annotation.getData().data);

            // TODO: extend the globe with functionality to add patches in runtime
            // this is hack as (w)hole really because the globe model concept is based on render globe from public data, then use patches for detailed patches of trrain and the place particular models on it.
            // The concept of octree is so that we will probably need another worker for handling the octree separated from the globe in future
            let globeModelElement = Factory.create(GlobeModel.TypeName, this._modelDescription);
            globeModelElement.parse({
                UID: "gis",
                models: [
                    {
                        name: this._modelDescription.projectInfo.getProperties().modelName,
                        levels: annotationDataObject.levels,
                        nc: annotationDataObject.nc,
                        size: annotationDataObject.size,
                        top: annotationDataObject.top,
                        bottom: annotationDataObject.bottom,
                    }
                ],
                type: "GlobeModel"
            });
        }
    }
}

Factory.register("Octree", Octree);